import { createFileRoute } from "@tanstack/react-router";
import { MerchProductDetail } from "../../components/merch/product-detail";

/** One product: its fields, its variant stock grid and its photos. */
export const Route = createFileRoute("/_app/merchandising/products/$productId")({
	component: ProductPage,
});

function ProductPage() {
	const { productId } = Route.useParams();
	return <MerchProductDetail key={productId} productId={productId} />;
}
